import { ReactElement, useRef, useState } from 'react';

import { toCurrency } from 'utils/numbers';
import { Component as InfoIcon } from 'icons/icon-circle--info.svg';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function ColoradoRDFLine(fee: number): ReactElement {
  const [show, setShow] = useState(false);
  const handleOnMouseEnter = () => {
    setShow(true);
  };
  const handleOnMouseLeave = () => {
    setShow(false);
  };
  const ref = useRef(null);

  if (fee === 0) {
    return (<></>);
  }

  return (
    <>
      <div className="d-flex align-items-baseline justify-content-between">
        Retail Delivery Fee
        <OverlayTrigger
          placement="top"
          show={show}
          overlay={(
            <Tooltip className="c-order-details__tooltip" id="tooltip-colorado-rdf" onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
              Colorado requires us to collect this fee for all orders containing
              sales tax and being delivered to the state of Colorado.
              <a
                href="https://tax.colorado.gov/retail-delivery-fee"
                target="_blank"
                rel="noreferrer"
                className="ml-2"
              >
                Read more
              </a>
              .
            </Tooltip>
          )}
        >
          <span
            className="mt-0 ml-2 c-info-icon"
            ref={ref}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          >
            <InfoIcon />
          </span>
        </OverlayTrigger>
        <div className="c-order-details__hr" />
        <div>{toCurrency(fee)}</div>
      </div>
    </>
  );
}

export default ColoradoRDFLine;
